// ABOUTME: Downloads private MCP files through the existing authenticated Compleo session.
// ABOUTME: Leaves owner, connection, expiry and current permission checks to the backend.
import React from "react";
import { Box, Button, Paper, Typography } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import Page from "Pages/_Layouts/DefaultInternal";
import { mcpPanelDownload } from "./api";
export default function McpDownload() {
    const [t] = useTranslation("MCP", { useSuspense: false });
    const [busy, setBusy] = React.useState(false);
    const [error, setError] = React.useState(false);
    const fileId =
        new URLSearchParams(window.location.search).get("file") || "";
    async function download() {
        setBusy(true);
        setError(false);
        try {
            await mcpPanelDownload(fileId);
        } catch {
            setError(true);
        } finally {
            setBusy(false);
        }
    }
    return (
        <Page featureName={t("downloadTitle")} maxWidth="sm">
            <Paper>
                <Box p={3}>
                    <Typography paragraph>
                        {t("downloadDescription")}
                    </Typography>
                    {error && (
                        <Typography color="error" role="alert">
                            {t("downloadUnavailable")}
                        </Typography>
                    )}
                    <Button
                        variant="contained"
                        color="primary"
                        disabled={busy || !/^[A-Za-z0-9_-]{43}$/.test(fileId)}
                        onClick={download}
                    >
                        {t(busy ? "working" : "download")}
                    </Button>
                </Box>
            </Paper>
        </Page>
    );
}
